export const INTRODUCTION = 'introduction'
export const ELEMENTARY_AND_MIDDLE_SCHOOL_ELA = 'elementaryAndMiddleSchoolELA'
export const ENGLISH_LEARNERS = 'englishLearners'
export const HIGH_SCHOOL_ELA = 'highSchoolELA'
export const SOCIAL_STUDIES = 'socialStudies'

export const imagesBaseSrc = `${window.postbuildEnv.CDN_URL}/images`
export const videosBaseSrc = `${window.postbuildEnv.CDN_URL}/videos`
export const sharedSlidesBaseSrc = `${imagesBaseSrc}/pages/onboarding_slides/shared`
